import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const loadTranslation = (language) => {
  switch (language) {
    case "en":
      return import("./en-US.js");
    case "zh":
      return import("./zh-CN.js");
    case "jp":
      return import("./ja-JP.js");
    default:
      return import("./en-US.js");
  }
};

/** Loads only the active (and fallback en) bundles — keeps locale JSON out of the main chunk until needed. */
export async function initI18n(language) {
  const lng = ["en", "zh", "jp"].includes(language) ? language : "en";

  const [primary, english] = await Promise.all([
    loadTranslation(lng),
    lng !== "en" ? loadTranslation("en") : Promise.resolve(null),
  ]);

  const resources = {
    [lng]: { translation: primary.default },
  };
  if (english) {
    resources.en = { translation: english.default };
  }

  if (!i18n.isInitialized) {
    await i18n.use(initReactI18next).init({
      resources,
      lng,
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
      },
    });
  } else {
    Object.keys(resources).forEach((code) => {
      if (!i18n.hasResourceBundle(code, "translation")) {
        i18n.addResourceBundle(code, "translation", resources[code].translation);
      }
    });
    await i18n.changeLanguage(lng);
  }
}

export default i18n;
